import * as React from 'react';
import { BallBeat } from 'react-pure-loaders';

import "./preloader.scss";

interface PreloaderProps {
    loading: boolean;
};

const Preloader = ({ loading }: PreloaderProps) => {
    if (!loading) return null;
    return (
        <div className={'preloader-wrap'}>
            <BallBeat
                color={'#123abc'}
                loading={loading}
            />
        </div>
    );
}

export default Preloader;